var map = {
	"./square/ac.svg": 1731,
	"./square/ad.svg": 1732,
	"./square/ae.svg": 1733,
	"./square/af.svg": 1734,
	"./square/ag.svg": 1735,
	"./square/ai.svg": 1736,
	"./square/al.svg": 1737,
	"./square/am.svg": 1738,
	"./square/ao.svg": 1739,
	"./square/aq.svg": 1740,
	"./square/ar.svg": 1741,
	"./square/as.svg": 1742,
	"./square/at.svg": 1743,
	"./square/au.svg": 1744,
	"./square/aw.svg": 1745,
	"./square/ax.svg": 1746,
	"./square/az.svg": 1747,
	"./square/ba.svg": 1748,
	"./square/bb.svg": 1749,
	"./square/bd.svg": 1750,
	"./square/be.svg": 1751,
	"./square/bf.svg": 1752,
	"./square/bg.svg": 1753,
	"./square/bh.svg": 1754,
	"./square/bi.svg": 1755,
	"./square/bj.svg": 1756,
	"./square/bl.svg": 1757,
	"./square/bm.svg": 1758,
	"./square/bn.svg": 1759,
	"./square/bo.svg": 1760,
	"./square/bq.svg": 1761,
	"./square/br.svg": 1762,
	"./square/bs.svg": 1763,
	"./square/bt.svg": 1764,
	"./square/bv.svg": 1765,
	"./square/bw.svg": 1766,
	"./square/by.svg": 1767,
	"./square/bz.svg": 1768,
	"./square/ca.svg": 1769,
	"./square/cc.svg": 1770,
	"./square/cd.svg": 1771,
	"./square/cefta.svg": 1772,
	"./square/cf.svg": 1773,
	"./square/cg.svg": 1774,
	"./square/ch.svg": 1775,
	"./square/ci.svg": 1776,
	"./square/ck.svg": 1777,
	"./square/cl.svg": 1778,
	"./square/cm.svg": 1779,
	"./square/cn.svg": 1780,
	"./square/co.svg": 1781,
	"./square/cp.svg": 1782,
	"./square/cr.svg": 1783,
	"./square/cu.svg": 1784,
	"./square/cv.svg": 1785,
	"./square/cw.svg": 1786,
	"./square/cx.svg": 1787,
	"./square/cy.svg": 1788,
	"./square/cz.svg": 1789,
	"./square/de.svg": 1790,
	"./square/dg.svg": 1791,
	"./square/dj.svg": 1792,
	"./square/dk.svg": 1793,
	"./square/dm.svg": 1794,
	"./square/do.svg": 1795,
	"./square/dz.svg": 1796,
	"./square/ea.svg": 1797,
	"./square/ec.svg": 1798,
	"./square/ee.svg": 1799,
	"./square/eg.svg": 1800,
	"./square/eh.svg": 1801,
	"./square/er.svg": 1802,
	"./square/es-ct.svg": 1803,
	"./square/es-ga.svg": 1804,
	"./square/es.svg": 1805,
	"./square/et.svg": 1806,
	"./square/eu.svg": 1807,
	"./square/fi.svg": 1808,
	"./square/fj.svg": 1809,
	"./square/fk.svg": 1810,
	"./square/fm.svg": 1811,
	"./square/fo.svg": 1812,
	"./square/fr.svg": 1813,
	"./square/ga.svg": 1814,
	"./square/gb-eng.svg": 1815,
	"./square/gb-nir.svg": 1816,
	"./square/gb-sct.svg": 1817,
	"./square/gb-wls.svg": 1818,
	"./square/gb.svg": 1819,
	"./square/gd.svg": 1820,
	"./square/ge.svg": 1821,
	"./square/gf.svg": 1822,
	"./square/gg.svg": 1823,
	"./square/gh.svg": 1824,
	"./square/gi.svg": 1825,
	"./square/gl.svg": 1826,
	"./square/gm.svg": 1827,
	"./square/gn.svg": 1828,
	"./square/gp.svg": 1829,
	"./square/gq.svg": 1830,
	"./square/gr.svg": 1831,
	"./square/gs.svg": 1832,
	"./square/gt.svg": 1833,
	"./square/gu.svg": 1834,
	"./square/gw.svg": 1835,
	"./square/gy.svg": 1836,
	"./square/hk.svg": 1837,
	"./square/hm.svg": 1838,
	"./square/hn.svg": 1839,
	"./square/hr.svg": 1840,
	"./square/ht.svg": 1841,
	"./square/hu.svg": 1842,
	"./square/ic.svg": 1843,
	"./square/id.svg": 1844,
	"./square/ie.svg": 1845,
	"./square/il.svg": 1846,
	"./square/im.svg": 1847,
	"./square/in.svg": 1848,
	"./square/io.svg": 1849,
	"./square/iq.svg": 1850,
	"./square/ir.svg": 1851,
	"./square/is.svg": 1852,
	"./square/it.svg": 1853,
	"./square/je.svg": 1854,
	"./square/jm.svg": 1855,
	"./square/jo.svg": 1856,
	"./square/jp.svg": 1857,
	"./square/ke.svg": 1858,
	"./square/kg.svg": 1859,
	"./square/kh.svg": 1860,
	"./square/ki.svg": 1861,
	"./square/km.svg": 1862,
	"./square/kn.svg": 1863,
	"./square/kp.svg": 1864,
	"./square/kr.svg": 1865,
	"./square/kw.svg": 1866,
	"./square/ky.svg": 1867,
	"./square/kz.svg": 1868,
	"./square/la.svg": 1869,
	"./square/lb.svg": 1870,
	"./square/lc.svg": 1871,
	"./square/li.svg": 1872,
	"./square/lk.svg": 1873,
	"./square/lr.svg": 1874,
	"./square/ls.svg": 1875,
	"./square/lt.svg": 1876,
	"./square/lu.svg": 1877,
	"./square/lv.svg": 1878,
	"./square/ly.svg": 1879,
	"./square/ma.svg": 1880,
	"./square/mc.svg": 1881,
	"./square/md.svg": 1882,
	"./square/me.svg": 1883,
	"./square/mf.svg": 1884,
	"./square/mg.svg": 1885,
	"./square/mh.svg": 1886,
	"./square/mk.svg": 1887,
	"./square/ml.svg": 1888,
	"./square/mm.svg": 1889,
	"./square/mn.svg": 1890,
	"./square/mo.svg": 1891,
	"./square/mp.svg": 1892,
	"./square/mq.svg": 1893,
	"./square/mr.svg": 1894,
	"./square/ms.svg": 1895,
	"./square/mt.svg": 1896,
	"./square/mu.svg": 1897,
	"./square/mv.svg": 1898,
	"./square/mw.svg": 1899,
	"./square/mx.svg": 1900,
	"./square/my.svg": 1901,
	"./square/mz.svg": 1902,
	"./square/na.svg": 1903,
	"./square/nc.svg": 1904,
	"./square/ne.svg": 1905,
	"./square/nf.svg": 1906,
	"./square/ng.svg": 1907,
	"./square/ni.svg": 1908,
	"./square/nl.svg": 1909,
	"./square/no.svg": 1910,
	"./square/np.svg": 1911,
	"./square/nr.svg": 1912,
	"./square/nu.svg": 1913,
	"./square/nz.svg": 1914,
	"./square/om.svg": 1915,
	"./square/pa.svg": 1916,
	"./square/pe.svg": 1917,
	"./square/pf.svg": 1918,
	"./square/pg.svg": 1919,
	"./square/ph.svg": 1920,
	"./square/pk.svg": 1921,
	"./square/pl.svg": 1922,
	"./square/pm.svg": 1923,
	"./square/pn.svg": 1924,
	"./square/pr.svg": 1925,
	"./square/ps.svg": 1926,
	"./square/pt.svg": 1927,
	"./square/pw.svg": 1928,
	"./square/py.svg": 1929,
	"./square/qa.svg": 1930,
	"./square/re.svg": 1931,
	"./square/ro.svg": 1932,
	"./square/rs.svg": 1933,
	"./square/ru.svg": 1934,
	"./square/rw.svg": 1935,
	"./square/sa.svg": 1936,
	"./square/sb.svg": 1937,
	"./square/sc.svg": 1938,
	"./square/sd.svg": 1939,
	"./square/se.svg": 1940,
	"./square/sg.svg": 1941,
	"./square/sh.svg": 1942,
	"./square/si.svg": 1943,
	"./square/sj.svg": 1944,
	"./square/sk.svg": 1945,
	"./square/sl.svg": 1946,
	"./square/sm.svg": 1947,
	"./square/sn.svg": 1948,
	"./square/so.svg": 1949,
	"./square/sr.svg": 1950,
	"./square/ss.svg": 1951,
	"./square/st.svg": 1952,
	"./square/sv.svg": 1953,
	"./square/sx.svg": 1954,
	"./square/sy.svg": 1955,
	"./square/sz.svg": 1956,
	"./square/ta.svg": 1957,
	"./square/tc.svg": 1958,
	"./square/td.svg": 1959,
	"./square/tf.svg": 1960,
	"./square/tg.svg": 1961,
	"./square/th.svg": 1962,
	"./square/tj.svg": 1963,
	"./square/tk.svg": 1964,
	"./square/tl.svg": 1965,
	"./square/tm.svg": 1966,
	"./square/tn.svg": 1967,
	"./square/to.svg": 1968,
	"./square/tr.svg": 1969,
	"./square/tt.svg": 1970,
	"./square/tv.svg": 1971,
	"./square/tw.svg": 1972,
	"./square/tz.svg": 1973,
	"./square/ua.svg": 1974,
	"./square/ug.svg": 1975,
	"./square/um.svg": 1976,
	"./square/un.svg": 1977,
	"./square/us.svg": 1978,
	"./square/uy.svg": 1979,
	"./square/uz.svg": 1980,
	"./square/va.svg": 1981,
	"./square/vc.svg": 1982,
	"./square/ve.svg": 1983,
	"./square/vg.svg": 1984,
	"./square/vi.svg": 1985,
	"./square/vn.svg": 1986,
	"./square/vu.svg": 1987,
	"./square/wf.svg": 1988,
	"./square/ws.svg": 1989,
	"./square/xk.svg": 1990,
	"./square/xx.svg": 1991,
	"./square/ye.svg": 1992,
	"./square/yt.svg": 1993,
	"./square/za.svg": 1994,
	"./square/zm.svg": 1995,
	"./square/zw.svg": 1996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1730;